import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-10 text-center animate-fade-up" data-testid="payment-cancel">
        <XCircle className="h-14 w-14 text-slatebody mx-auto mb-4" />
        <h1 className="font-display text-xl font-bold text-navy">{t("payment.cancelledTitle")}</h1>
        <p className="text-slatebody mt-2">{t("payment.cancelledMsg")}</p>
        <Button className="mt-6 bg-[#ECECEC] hover:bg-[#E0E0E0] text-[#202123] border border-[#C5C5D0]" onClick={() => navigate("/app/billing")} data-testid="cancel-back">{t("payment.backToBilling")}</Button>
      </div>
    </div>
  );
}
